import Column from '@components/Column';
import Row from '@components/Row';
import { OrderLine } from '@models/order';

import CartContent from './CartContent';
import CartFooter from './CartFooter';
import CartImage from './CartImage';

interface Props {
    item: OrderLine;
}

function CartItem({ item }:Props) {
    return (
        <Column fullWidth spacing={4} >
            <Row spacing={4} align='flex-start' fullWidth>
                <CartImage item={item} />
                <CartContent item={item} />
            </Row>
            <CartFooter item={item} />
        </Column>
    );
}

export default CartItem;
